/** 角色菜单权限配置 */
export const ROLE_MENU_PATHS = {
  admin: null,
  customer: ['/llm', '/billing']
}

/** 角色隐藏的子页面（侧边栏不展示，且禁止直接访问） */
export const ROLE_HIDDEN_PATHS = {
  customer: ['/billing/invoice']
}

/** 客户角色可访问的额外页面（不在侧边栏展示） */
const CUSTOMER_EXTRA_PATHS = [
  '/user/profile',
  '/help/center',
  '/help/contact',
  '/help/feedback'
]

export function getDefaultRoute(role = 'admin') {
  return role === 'customer' ? '/llm/list' : '/dashboard'
}

export function isRouteHiddenForRole(path, role = 'admin') {
  const hiddenPaths = ROLE_HIDDEN_PATHS[role] || []
  if (!hiddenPaths.length || !path) {
    return false
  }

  const normalizedPath = path.toLowerCase()
  return hiddenPaths.some(hidden => {
    const normalizedHidden = hidden.toLowerCase()
    return normalizedPath === normalizedHidden || normalizedPath.startsWith(`${normalizedHidden}/`)
  })
}

export function canShowInvoiceFeature(role = 'admin') {
  return !isRouteHiddenForRole('/billing/invoice', role)
}

export function canAccessRoute(path, role = 'admin') {
  if (!path || path === '/login' || path === '/agreement') {
    return true
  }

  if (isRouteHiddenForRole(path, role)) {
    return false
  }

  const allowedMenus = ROLE_MENU_PATHS[role]
  if (!allowedMenus) {
    return true
  }

  const normalizedPath = path.toLowerCase()

  if (CUSTOMER_EXTRA_PATHS.some(item => normalizedPath === item || normalizedPath.startsWith(`${item}/`))) {
    return true
  }

  return allowedMenus.some(prefix => {
    return normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
  })
}

export function filterMenuRoutes(routes, role = 'admin') {
  const allowedMenus = ROLE_MENU_PATHS[role]

  return routes.filter(route => {
    if (route.path === '/login' || route.path === '/agreement') {
      return false
    }
    if (route.meta && route.meta.hidden) {
      return false
    }
    if (!allowedMenus) {
      return route.path !== '/agreement'
    }
    return allowedMenus.includes(route.path)
  }).map(route => {
    if (!route.children || !route.children.length) {
      return route
    }

    return {
      ...route,
      children: route.children.filter(child => {
        const fullPath = `${route.path}/${child.path}`.replace(/\/+/g, '/')
        return !isRouteHiddenForRole(fullPath, role)
      })
    }
  })
}
